import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackgroundChecksComponent } from './background-checks.component';
import { AgGridModule } from "ag-grid-angular";
import { BackgroundCheckService } from "../../../../services/background-check.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Trip2ThemeModule } from "../../../../trip2-theme/trip2-theme.module";
import { BackgroundChecksFormComponent } from './background-checks-form/background-checks-form.component';
import { OnDemandDriversModule } from "../../../on-demand-drivers/on-demand-drivers.module";
import { DriverBackgroundCheckModule } from '../../../../utils/driver-background-check/driver-background-check.module';
import { DriverBackgroundCheckApiService } from '../../../../utils/driver-background-check/driver-background-check-api.service';

@NgModule({
    imports: [
        CommonModule,
        AgGridModule,
        FormsModule,
        Trip2ThemeModule,
        ReactiveFormsModule,
        OnDemandDriversModule,
        DriverBackgroundCheckModule
    ],
  declarations: [ BackgroundChecksComponent, BackgroundChecksFormComponent ],
  providers: [ BackgroundCheckService, DriverBackgroundCheckApiService ]
})
export class BackgroundChecksModule { }



// WEBPACK FOOTER //
// ./src/app/pages/administration/fleet/background-checks/background-checks.module.ts